/* global Event */

export function pick (arr) {
  return arr[Math.floor(Math.random() * arr.length)]
}

export function pickVisibleOption (selectEl) {
  const options = Array.from(selectEl.options).slice(1) // skip "Please select"
  if (!options.length) return null
  return pick(options)
}

export function pickFilteredOption (selectEl, dataAttr, parentValue) {
  const proxyMenu = selectEl.parentElement.querySelector('.vjs-proxy-select__menu')
  if (!proxyMenu) return pickVisibleOption(selectEl)

  const visibleItems = Array.from(proxyMenu.querySelectorAll('li'))
    .filter(li => !li.classList.contains('hidden') && li.dataset[dataAttr] === String(parentValue))

  if (!visibleItems.length) return null

  const chosenText = pick(visibleItems).innerText
  return Array.from(selectEl.options).find(opt => opt.text === chosenText) || null
}

export function setNativeSelect (selectEl, option) {
  if (!selectEl || !option) return

  selectEl.selectedIndex = option.index
  selectEl.disabled = false

  const container = selectEl.closest('.vjs-custom-select__container')
  if (container) {
    container.classList.remove('vsd-custom-select__container--disabled', 'vjs-custom-select__container--disabled')
  }

  const proxy = selectEl.parentElement.querySelector('.vjs-proxy-select__display')
  if (proxy) proxy.innerText = option.text

  selectEl.dispatchEvent(new Event('change', { bubbles: true }))
}

export function setInputValue (selector, value) {
  const el = document.querySelector(selector)
  if (el && value !== undefined) {
    el.value = value
    el.dispatchEvent(new Event('input', { bubbles: true }))
  }
}

export function setRadio (name, value) {
  const radio = document.querySelector(`input[type="radio"][name="${name}"][value="${value}"]`)
  if (radio) {
    radio.checked = true
    radio.dispatchEvent(new Event('change', { bubbles: true }))
  }
}

export function selectRandomOption (selectId) {
  const selectEl = document.getElementById(selectId)
  if (!selectEl) return

  const option = pickVisibleOption(selectEl)
  if (option) setNativeSelect(selectEl, option)
}
